module.exports = __webpack_public_path__ + "static/media/247.eb951516.png";